import { Controller } from "@hotwired/stimulus";
import Choices from "choices.js";

export default class extends Controller {
  connect() {
    // this avoid multiple initialization of choices
    if (this.element.dataset.choice != "active") {
      this.initializeChoices();
    }
  }

  initializeChoices() {
    const options = {
      addItems: true,
      removeItemButton: true,
    };

    this.element.value = this.element.value.split(" ").join(",");
    new Choices(this.element, options);
  }
}
